/* eslint-disable id-length, no-param-reassign, no-shadow */
import CSS from 'css';
import React from 'react';

const IS_DEV = process.env.NODE_ENV === 'development';

export function m(...styles) {
  styles = styles.filter(Boolean);
  if (styles.length < 2) return styles[0];

  return Object.assign({}, ...styles);
}

export function cn(...classNames) {
  return classNames
    // flattern
    .reduce((classNames, className) => classNames.concat(className), [])
    .filter(Boolean)
    .join(' ');
}

const re1 = /\.[a-z0-9_\-]+/img;
function extractClassNames(stylesheet) {
  return stylesheet.rules.reduce((result, rule) => {
    for (const selector of rule.selectors) {
      const matches = selector.match(re1);
      for (const match of matches) {
        const className = match.substr(1);
        // TODO - hash classnames and update stylesheet
        result[className] = className;
      }
    }
    return result;
  }, {});
}

export function css(strings, ...variables) {
  const text = strings.length > 1 ?
    strings.reduce((string, piece, index) => `${string}${variables[index]}${piece}`) :
    strings[0];

  const ast = CSS.parse(text, {source: '~/style.css'});

  const classNames = extractClassNames(ast.stylesheet);

  const code = CSS.stringify(ast, {compress: !IS_DEV});
  return {...classNames, el: <style scoped>{code}</style>};
}



// WEBPACK FOOTER //
// ./spa/css.jsx